(function () {
'use strict';
document.addEventListener('click', function (event) {
var btn = event.target.closest('[data-cart-upsell-add]');
if (!btn || btn.disabled) return;
event.preventDefault();
addUpsellProduct(btn);
});
document.addEventListener('change', function (event) {
var select = event.target.closest('[data-cart-upsell-variant-select]');
if (!select) return;
var card = select.closest('[data-cart-upsell-card]');
if (!card) return;
var btn = card.querySelector('[data-cart-upsell-add]');
if (!btn) return;
var selectedOption = select.options[select.selectedIndex];
btn.setAttribute('data-variant-id', select.value);
btn.disabled = selectedOption.disabled;
});
function removeUpsellCard(btn) {
var card = btn.closest('[data-cart-upsell-card]');
if (!card) return;
card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
card.style.opacity = '0';
card.style.transform = 'scale(0.95)';
setTimeout(function () {
card.remove();
}, 300);
}
function addUpsellProduct(btn) {
var variantId = btn.getAttribute('data-variant-id');
if (!variantId) {
console.warn('[cart-upsell] sem data-variant-id no botão — produto pode estar indisponível.');
return;
}
btn.disabled = true;
btn.classList.add('is-loading');
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({
items: [{ id: variantId, quantity: 1, properties: { '_Cart upsell item': 'true' } }]
})
})
.then(function (res) {
if (!res.ok) {
return res.json().then(function (err) {
throw new Error(err.description || 'Could not add product to cart.');
});
}
return res.json();
})
.then(function () {
document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
fetchCartAndSync();
removeUpsellCard(btn);
})
.catch(function (err) {
console.error('[cart-upsell] add to cart failed:', err);
alert('Atsiprašome, nepavyko įdėti prekės. Bandykite dar kartą.');
})
.finally(function () {
btn.disabled = false;
btn.classList.remove('is-loading');
});
}
function formatMoneyWithCurrency(cents) {
try {
if (window.theme && typeof window.theme.formatMoney === 'function') {
var format = window.theme.moneyWithCurrencyFormat || window.theme.moneyFormat;
return window.theme.formatMoney(cents, format);
}
} catch (e) {
console.warn('[cart-upsell] formatMoney do tema falhou, a usar fallback.', e);
}
return '$' + (cents / 100).toFixed(2) + ' AUD';
}
var TIERS = [
{ count: 2, percent: 10 },
{ count: 3, percent: 15 },
{ count: 4, percent: 20 },
{ count: 5, percent: 25 }
];
function syncProgressBar(cart) {
updateReservedBarVisibility(cart);
var bar = document.querySelector('[data-cart-upsell-progress]');
if (!bar) return;
var count = cart.item_count;
bar.setAttribute('data-item-count', count);
if (count === 0) {
bar.style.display = 'none';
return;
} else {
bar.style.display = '';
}
var message = document.querySelector('[data-cart-upsell-message]');
var nextTier = null;
for (var i = 0; i < TIERS.length; i++) {
if (count < TIERS[i].count) { nextTier = TIERS[i]; break; }
}
if (message) {
if (!nextTier) {
message.textContent = "Atrakinote didžiausią nuolaidą!";
} else {
var needed = nextTier.count - count;
message.textContent = 'Įdėkite dar ' + needed + (needed === 1 ? ' prekę' : (needed < 10 ? ' prekes' : ' prekių')) + ' ir gaukite papildomą ' + nextTier.percent + '% nuolaidą!';
}
}
var fillEl = document.querySelector('[data-cart-upsell-fill]');
if (fillEl) {
var fillRaw = ((count - 1) * 100) / 4;
if (fillRaw < 0) fillRaw = 0;
if (fillRaw > 100) fillRaw = 100;
fillEl.style.width = fillRaw + '%';
}
var currentTier = 0;
for (var j = TIERS.length - 1; j >= 0; j--) {
if (count >= TIERS[j].count) { currentTier = TIERS[j].percent; break; }
}
document.querySelectorAll('.cart-upsell-progress__marker').forEach(function (marker) {
var tierValue = parseInt(marker.getAttribute('data-tier'), 10);
var icon = marker.querySelector('.cart-upsell-progress__marker-icon');
if (!icon) return;
if (tierValue && tierValue <= currentTier) {
icon.classList.add('is-reached');
} else {
icon.classList.remove('is-reached');
}
if (tierValue === currentTier && currentTier > 0) {
icon.classList.add('is-current');
} else {
icon.classList.remove('is-current');
}
});
}
function syncSavings(cart) {
var container = document.querySelector('[data-cart-upsell-savings]');
if (!container) return;
var totalSavings = 0;
var totalOriginal = 0;
(cart.items || []).forEach(function (item) {
var original = item.original_line_price;
var final = (typeof item.final_line_price === 'number') ? item.final_line_price : item.line_price;
if (typeof original !== 'number') original = item.price * item.quantity;
if (typeof final !== 'number') final = item.price * item.quantity;
totalOriginal += original;
totalSavings += Math.max(0, original - final);
});
if (totalSavings > 0) {
container.style.display = '';
var valueEl = container.querySelector('[data-cart-upsell-savings-value]');
var wasEl = container.querySelector('[data-cart-upsell-savings-was]');
if (valueEl) valueEl.textContent = '-' + formatMoneyWithCurrency(totalSavings);
if (wasEl) wasEl.textContent = 'Buvo ' + formatMoneyWithCurrency(totalOriginal);
} else {
container.style.display = 'none';
}
}
function syncPerItemSavings(cart) {
(cart.items || []).forEach(function (item) {
var itemEl = document.querySelector('.cart__item[data-item="' + item.key + '"]');
if (!itemEl) return;
var priceEl = itemEl.querySelector('.cart__price');
if (!priceEl) return;
var savings = parseInt(itemEl.getAttribute('data-savings'), 10) || 0;
var badge = priceEl.querySelector('[data-cart-upsell-item-savings]');
if (savings > 0) {
if (!badge) {
badge = document.createElement('span');
badge.setAttribute('data-cart-upsell-item-savings', '');
badge.className = 'cart-upsell__item-savings';
priceEl.appendChild(badge);
}
badge.textContent = ('(Sutaupote ' + formatMoneyWithCurrency(savings) + ')').replace(/\s*[A-Z]{3}\b/, '');
} else if (badge) {
badge.remove();
}
});
}
var lastCartData = null;
var applyingItemBadges = false;
function applyItemBadgesSafely(cart) {
applyingItemBadges = true;
syncPerItemSavings(cart);
setTimeout(function () { applyingItemBadges = false; }, 0);
}
function fetchCartAndSync() {
fetch('/cart.js')
.then(function (res) { return res.json(); })
.then(function (cart) {
lastCartData = cart;
var count = cart.item_count;
if (lastItemCount !== null && count > lastItemCount) {
forceResetReservationTimer();
}
syncProgressBar(cart);
applyItemBadgesSafely(cart);
syncCheckoutButtonPrice(cart);
lastItemCount = count;
})
.catch(function (err) { console.error('[cart-upsell] could not fetch cart.js', err); });
}
function refreshUpsellProducts() {
fetch('/?section_id=cart-drawer')
.then(function (res) { return res.text(); })
.then(function (html) {
var parser = new DOMParser();
var doc = parser.parseFromString(html, 'text/html');
var newList = doc.querySelector('[data-cart-upsell-list]');
var currentList = document.querySelector('[data-cart-upsell-list]');
if (newList && currentList) {
currentList.innerHTML = newList.innerHTML;
}
})
.catch(function (err) { console.error('[cart-upsell] could not refresh upsell products', err); });
}
var applyingCheckoutPrice = false;
var checkoutPriceObserver = null;

function formatCheckoutPrice(totalPrice) {
  return (totalPrice / 100).toFixed(2).replace('.', ',') + '€';
}

function syncCheckoutButtonPrice(cart) {
  var priceEl = document.querySelector('[data-cart-checkout-price]');
  if (!priceEl) return;

  applyingCheckoutPrice = true;
  priceEl.textContent = formatCheckoutPrice(cart.total_price);
  setTimeout(function () { applyingCheckoutPrice = false; }, 0);

  if (!checkoutPriceObserver && window.MutationObserver) {
    checkoutPriceObserver = new MutationObserver(function () {
      if (applyingCheckoutPrice) return;
      if (lastCartData) syncCheckoutButtonPrice(lastCartData);
    });
    checkoutPriceObserver.observe(priceEl, { childList: true, characterData: true, subtree: true });
  }
}
document.addEventListener('DOMContentLoaded', function () {
fetchCartAndSync();
var itemsHolder = document.querySelector('[data-items-holder]');
if (itemsHolder && window.MutationObserver) {
var itemsObserver = new MutationObserver(function () {
if (applyingItemBadges) return;
if (lastCartData) applyItemBadgesSafely(lastCartData);
});
itemsObserver.observe(itemsHolder, { childList: true, subtree: true });
}
});
var nativeFetch = window.fetch.bind(window);
window.fetch = function () {
var url = arguments[0];
var urlString = typeof url === 'string' ? url : (url && url.url) || '';
var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?/.test(urlString);
return nativeFetch.apply(window, arguments).then(function (response) {
if (isCartMutation && response.ok) {
fetchCartAndSync();
}
return response;
});
};
[
'theme:cart:add',
'theme:cart:change',
'theme:cart:refresh',
'theme:product:add'
].forEach(function (eventName) {
document.addEventListener(eventName, function () {
fetchCartAndSync();
});
});
/**
 * Reservation bar — only ever shown for a fresh 5-minute window that starts
 * the moment a product is actually added to the cart (never just because
 * the drawer is opened or the page is reloaded with an already-stale cart).
 * Removing a product never resets or pauses the countdown — only a genuine
 * increase in item_count (an add) does that, via forceResetReservationTimer()
 * below, called from fetchCartAndSync() whenever the count goes up.
 */
var RESERVATION_STORAGE_KEY = 'cartUpsellReservationExpiry';
var RESERVATION_SECONDS = 5 * 60;
var lastItemCount = null;
function forceResetReservationTimer() {
var expiry = Date.now() + RESERVATION_SECONDS * 1000;
sessionStorage.setItem(RESERVATION_STORAGE_KEY, String(expiry));
updateReservedBarVisibility(lastCartData);
}
function getReservationExpiryTime() {
var stored = sessionStorage.getItem(RESERVATION_STORAGE_KEY);
if (!stored) return null;
var expiry = parseInt(stored, 10);
return isNaN(expiry) ? null : expiry;
}
function isReservationActive() {
var expiry = getReservationExpiryTime();
if (!expiry) return false;
if (expiry <= Date.now()) {
sessionStorage.removeItem(RESERVATION_STORAGE_KEY);
return false;
}
return true;
}
function updateReservedBarVisibility(cart) {
var reservedEl = document.querySelector('[data-cart-upsell-reserved]');
if (!reservedEl) return;
var count = cart ? cart.item_count : 0;
reservedEl.style.display = (count > 0 && isReservationActive()) ? '' : 'none';
}
function formatReservationTime(totalSeconds) {
var minutes = Math.floor(totalSeconds / 60);
var seconds = totalSeconds % 60;
return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
}
function reservationTick() {
updateReservedBarVisibility(lastCartData);
var timerEl = document.querySelector('[data-cart-upsell-timer]');
if (!timerEl) return;
var expiry = getReservationExpiryTime();
var remainingMs = expiry ? expiry - Date.now() : 0;
var remainingSeconds = Math.max(0, Math.floor(remainingMs / 1000));
timerEl.textContent = formatReservationTime(remainingSeconds);
}
reservationTick();
setInterval(reservationTick, 1000);
document.addEventListener('click', function (event) {
var prevBtn = event.target.closest('[data-cart-upsell-prev]');
var nextBtn = event.target.closest('[data-cart-upsell-next]');
if (!prevBtn && !nextBtn) return;
var list = document.querySelector('[data-cart-upsell-list]');
if (!list) return;
var card = list.querySelector('[data-cart-upsell-card]');
var scrollAmount = card ? card.getBoundingClientRect().width + 10 : 270;
list.scrollBy({
left: prevBtn ? -scrollAmount : scrollAmount,
behavior: 'smooth'
});
});
})();
